<template>
  <div class>
    <div class="event-setup-wrapper basic-info-wrap-area">
      <div class="container-fluid pt-4 pb-8">
        <!-- <v-btn dark color="primary" size="100px" @click="loaderOpen()"
          >Open</v-btn
        > -->
        <!-- <SelfServiceLeftMenu>
        </SelfServiceLeftMenu> -->

        <div class="right-setup-wrap" style="">
          <div class="custom-event-basic-setup-wrap">
            <h3>Basic Info</h3>
            <!-- <h4>Event Name &amp; Type</h4> -->
            <div v-if="EventData" class="event-add-setup-form">
              <v-row class="mt-4">
                <v-col cols="12" md="12" lg="12">
                  <label>Event Name*</label>
                    <v-text-field
                    outlined
                    type="Text"
                    :rules="[(v) => !!v || 'This field is required']"
                    required
                    class="ss-cns-name"
                    placeholder="Enter Event Name"
                    v-model="eventName"
                    counter
                    maxlength="200"
                  ></v-text-field>

                  <!-- <input
                    id="txtEventFullName"
                    type="text"
                    class="custom-input"
                    v-model="eventName"
                    required="required"
                  /> -->

                  <span class="d-block mb-4" v-if="showErrorMsg">
                    <v-icon color="red">info</v-icon>This field is
                    required</span
                  >
                </v-col>
                <!-- <v-col cols="12" md="12" lg="12">
                <label>Host Name</label>
                <input
                  id="txtEventFullName"
                  type="text"
                  class="custom-input"
                />
              </v-col> -->
                <!-- <v-col md="12" sm="12" cols="12">
                <label>Event Type</label>
                <v-select
                  outlined
                  label="Select a Event Type"
                  :items="locationOptions"
                  item-text="Name"
                  return-object
                  v-model="EventData.LocationType"
                ></v-select>
                <p class="virtualevent-txt">Virtual events have unique event pages where you can add links to livestreams and more</p>
              </v-col> -->
              </v-row>
              <h4>Date and Time</h4>
              <p>
                Tell event-goers when your event starts and ends so they can
                make plans to attend.
              </p>
              <v-row class="mt-4">
                <v-col md="12" sm="12" cols="12">
                  <label>Time Zone</label>
                  
                  <v-select
                    outlined
                    label="Select a Time Zone"
                    :items="TimeZones"
                    item-text="label"
                    item-value="value"
                    v-model="defaultUserTimeZone"
                  ></v-select>
                </v-col>
                <v-col md="12" sm="12" cols="12">
                  <v-row>
                    <v-col md="6" sm="6" cols="12">
                      <label>Start</label>
                      <flat-pickr
                        placeholder="MM/DD/YYYY"
                        class="text-uppercase custom-input"
                        v-model="defaultUserStartDateTime"
                        :config="configdateTimePickerStart"
                      />
                    </v-col>
                    <v-col md="6" sm="6" cols="12">
                      <label>End</label>
                      <flat-pickr
                        placeholder="MM/DD/YYYY"
                        class="text-uppercase custom-input"
                        v-model="defaultUserEndDateTime"
                        :config="configdateTimePickerEnd"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
          <div
            class="
              d-flex
              mt-8
              justify-content-end
              align-items-center
              button-proceed
            "
          >
            <v-btn
              class="mr-2 cancel-standard"
              outlined
              color="#1c1d26"
              @click="CancelBasicSetup"
              large
            >
              Cancel
            </v-btn>

            <v-btn
              class="px-6 save-standard"
              dark
              large
              color="#2376e5"
              @click="saveNewAdminEvent"
              :loading="SaveingBasicSetup"
            >
              Save &amp; Next
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="320"
      v-model="loaderDialog"
      persistent
    >
      <v-card class="losder-class-wrap">
        <v-card-text>
          <div class="loader-sec-wrapper">
            <div class="loader-wrap">
              <div class="lds-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <p>Please wait while we are creating the event for you..</p>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import APIs from "@/components/APIInit";
import axios from "axios";
import store from "@/store";
// import jQuery from "jquery";
// let $ = jQuery;
import { bus } from "@/main";
import common from "@/common";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import router from "../router";
import db from "../components/firebaseInit";
import firebase from "firebase";
import jwt_decode from "jwt-decode";

var vm;
var eventCloneProgress;
export default {
  components: {
    flatPickr,
  },
  data() {
    return {
      showErrorMsg: false,
      eventName: null,
      displayName: null,
      eventId: null,
      clientId: null,
      timeZones: [],
      defaultUserTimeZone: null,
      defaultUserStartDateTime: null,
      defaultUserEndDateTime: null,
      defaultUserStartTime: null,
      defaultUserEndTime: null,
      defaultTemplateClientId: null,

      radios2: null,
      locationOptions: [
        { Id: 1, Name: "In-person" },
        { Id: 2, Name: "Virtual" },
        { Id: 3, Name: "Hybrid" },
      ],
      TimeZones: [{ label: "Select a Time Zone", value: "" }],
      PasscodeOptions: [
        "Unique Passcode per Attendee",
        "Use Common Event Passcode",
      ],
      LanguageOptions: ["Chinese", "English", "French", "German"],
      configdateTimePickerStart: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
        minDate: "today",
        onChange: function (val) {
          if (val) vm.configdateTimePickerEnd.minDate = new Date(val);
          if (val) vm.defaultUserEndDateTime = new Date(val).setHours(new Date(val).getHours() + 1);
        },
      },

      configdateTimePickerEnd: {
        minDate: null,
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
      ex4: ["red"],
      //event_collectionName: "",
      EventData: {},
      HostInfo: {},
      SaveingBasicSetup: false,
      LightTheme: {
        topBar: "#FFFFFF",
        headerBar: "#FFFFFF",
        fontBar: "#000000",
        sideNavigationAndIconColor: "#64656E",
      },
      DarkTheme: {
        topBar: "#000000",
        headerBar: "#000000",
        fontBar: "#3a3a3a",
        sideNavigationAndIconColor: "#000000",
      },
      appColorHexCodeType: "",
      headerColorsHexCode: {},
      hostName: "",
      clientName: "",
      customDomain: "",
      loaderDialog: false,
      tempAdminEvent: null,
      refreshTokenSuccess: false,
      collectionDetails: [],
    };
  },
  computed: {},
  watch: {
    refreshTokenSuccess(val) {
      if (val) {
        if (vm.collectionDetails && vm.collectionDetails.length == 2) {
          vm.ChangeCurrentEvent(
            vm.collectionDetails[0],
            vm.collectionDetails[1],
            true
          );
        }
      }
    },
  },
  created() {
    vm = this;
  },
  mounted() {
    // vm.noEventLink = vm.$t("client.registerRoute");
    // vm.clientID = vm.$route.query.c;
    // vm.tokenForUser = vm.$route.query.sst;
    // if (vm.tokenForUser != "") {
    //   vm.registerUserForEventAdmin();
    // }
    //vm.event_collectionName = vm.getEventCollectionName();

    vm.clientId = vm.$store.state.client[0].id;

    vm.defaultUserStartDateTime = moment()
      .add(1, "hour")
      .startOf("hour")
      .format("MM/DD/YYYY HH:mm ");

    vm.defaultUserEndDateTime = moment()
      .add(2, "hour")
      .startOf("hour")
      .format("MM/DD/YYYY HH:mm ");
    //vm.defaultUserStartTime = moment().add(1, "hour").startOf('hour').format("HH:mm");
    //vm.defaultUserEndTime = moment().add(2, "hour").startOf('hour').format("HH:mm");

    if (vm.defaultUserStartTime > vm.defaultUserEndTime) {
      vm.defaultUserEndDateTime = moment()
        .add(1, "day")
        .format("MM/DD/YYYY HH:mm ");
    }

    vm.defaultUserTimeZone = moment.tz.guess();
    vm.TimeZones = [{ label: "Select a Time Zone", value: "" }].concat(
      common.getTimeZones()
    );
    //vm.GetEventDetails();

    setTimeout(() => {
      var el = document.getElementById("txtEventFullName");
      if (el) {
        el.focus();
      }
    }, 500);
  },
  methods: {
    async refreshIdToken() {
      var xyz = await firebase.auth().onAuthStateChanged(async function (user) {
        if (user) {
          await firebase
            .auth()
            .currentUser.getIdToken(true)
            .then(async (idToken) => {
              var decoded = jwt_decode(idToken);
              document.cookie = "token=";
              document.cookie = "token=" + idToken + ";";
              store.commit("setCurrentLoggedInTime", decoded.exp);
              store.commit("addToken", idToken);
              await vm.displayEvents();
            })
            .catch((err) => {
              console.log("token set error==", err);
            });
        }
      });
      console.log(xyz);
    },
    async displayEvents() {
      var mappedEvents = [];
      let headers = {
        Authorization: "Bearer " + vm.getSessionToken(),
        "content-type": "application/json",
      };
      await axios
        .get(APIs.UserEvent, {
          headers: headers,
        })
        .then(async (response) => {
          var clients = response.data.result;
          var AdminRoles = [];
          if (response.data.profile && response.data.profile.AdminRoles) {
            store.commit("setAdminRoles", response.data.profile.AdminRoles);
            AdminRoles = response.data.profile.AdminRoles;
          }
          for (var n = 0; n < clients.length; n++) {
            var client = clients[n];
            var events = client.events;
            var currentTime = parseInt(new Date().getTime() / 1000);
            for (var i = 0; i < events.length; i++) {
              var event = events[i];
              mappedEvents.push(event);
              var dtstrt = parseInt(
                new Date(event.EventStartDateTime).getTime() / 1000
              );
              var dtEnd = parseInt(
                new Date(event.EventEndDateTime).getTime() / 1000
              );

              if (dtstrt > currentTime) {
                event.status = "upcoming";
              } else if (dtstrt <= currentTime && dtEnd >= currentTime) {
                if (!event.IsPublished) {
                  event.status = "underreview";
                } else {
                  event.status = "live";
                }
              } else {
                event.status = "ended";
              }

              var adminEvents = AdminRoles.filter(function (item) {
                return (
                  item.ClientId == event.ClientId &&
                  item.EventId == event.EventId
                );
              });

              if (adminEvents.length == 0) {
                continue;
              }
              //let startTime = event.EventStartDateTime.substring(11, 16);
              //let endTime = event.EventEndDateTime.substring(11, 16);
              // var eventNewStartTime = self.SetTimeByZone(
              //   moment(event.EventStartDate, ["DD-MM-YYYY"]).format(
              //     "MMM DD, YYYY"
              //   ),
              //   moment.tz.guess()
              // );
              // var eventNewEndTime = self.SetTimeByZone(
              //   moment(event.EventEndDate, ["DD-MM-YYYY"]).format(
              //     "MMM DD, YYYY"
              //   ),
              //   moment.tz.guess()
              // );

              // var eventDateStringLabel =
              //   eventNewStartTime != eventNewEndTime
              //     ? eventNewStartTime + " to " + eventNewEndTime
              //     : eventNewStartTime;
            }
            store.commit("setMappedEvent", mappedEvents);
            store.commit("addEventCount", mappedEvents.length);
          }
          await vm.refreshToken(response.data.customToken);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async refreshToken(token) {
      await firebase
        .auth()
        .signInWithCustomToken(token)
        .then(async function (res) {
          await res.user
            .getIdToken(true)
            .then(async (idToken) => {
              var decoded = jwt_decode(idToken);
              document.cookie = "token=";
              document.cookie = "token=" + idToken + ";";
              vm.$store.commit("addToken", idToken);
              vm.$store.commit("setCurrentLoggedInTime", decoded.exp);
              document.cookie = "staysigned=";
              document.cookie = "userrole=";
              document.cookie = "userid=";
              //alert("refreshToken success");
              vm.refreshTokenSuccess = true;
            })
            .catch((err) => {
              console.log("err=====", err);
            });
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    async CreateEventProgress() {
      vm.tempAdminEvent = vm.$store.getters.getTempAdminEvent;

      if (vm.tempAdminEvent && !vm.tempAdminEvent.DocPath) {
        vm.tempAdminEvent = null;
      }
      if (vm.tempAdminEvent && vm.tempAdminEvent.DocPath) {
        //self.tempAdminEvent.Status = "In Progress";
        if (eventCloneProgress) {
          eventCloneProgress();
          eventCloneProgress = undefined;
        }
        eventCloneProgress = db
          .doc(vm.tempAdminEvent.DocPath)
          .onSnapshot(async (doc) => {
            if (doc.exists) {
              let data = doc.data();
              vm.tempAdminEvent.StatusId = parseInt(data.status);
              if (isNaN(vm.tempAdminEvent.StatusId)) {
                vm.tempAdminEvent.StatusId = 0;
              }
              //alert("in "+self.tempAdminEvent.StatusId);
              vm.tempAdminEvent.Status = data.msg;

              vm.tempAdminEvent = {
                DocPath: vm.tempAdminEvent.DocPath,
                EventFullName: vm.tempAdminEvent.EventFullName,
                StatusId: vm.tempAdminEvent.StatusId,
                Status: vm.tempAdminEvent.Status,
              };
              if (vm.tempAdminEvent.StatusId == 200) {
                if (eventCloneProgress) {
                  eventCloneProgress();
                  eventCloneProgress = undefined;
                }

                vm.tempAdminEvent = null;
                store.commit("setTempAdminEvent", {});

                vm.loaderDialog = false;
                var path = data.path;

                var last = path.substring(
                  path.lastIndexOf("_") + 1,
                  path.length
                );
                vm.collectionDetails = last.match(/.{1,14}/g);
                await vm.refreshIdToken();
                // alert(abc);
                // alert("call ChangeCurrentEvent");

                // setTimeout(() => {
                //   vm.ChangeCurrentEvent(
                //     collectionDetails[0],
                //     collectionDetails[1],
                //     true
                //   );
                // }, 5000);
                //alert("event changes completed");
                //vm.refreshIdToken();
              } else if (vm.tempAdminEvent.StatusId < 0) {
                vm.loaderDialog = false;
                vm.showSnackbar(
                  "Something went wrong. Click Retry to create the event",
                  "error",
                  "top"
                );
              }
            }
          });
      }
    },
    async saveNewAdminEvent() {

      if (this.eventName) {
        this.showErrorMsg = false;

        
        if(!this.defaultUserStartDateTime || !this.defaultUserEndDateTime){
         this.showSnackbar("Start/End date cannot be empty", "error", "top");
        return;
      }
        // bus.$emit("toggleLoader", true);
        //vm.loaderDialog = true;
        bus.$emit("toggleSelfServiceEventCreateLoader", true);
        var headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + this.getSessionToken(),
        };

        var startD = this.GetTimeByZone(
          this.defaultUserStartDateTime,
          this.defaultUserTimeZone
        );
        var endD = this.GetTimeByZone(
          this.defaultUserEndDateTime,
          this.defaultUserTimeZone
        );

        var requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: vm.$store.getters.getClonedTemplateMasterDetails.ClientId, //self.clientID,
            eventId: vm.$store.getters.getClonedTemplateMasterDetails.EventId,
            targetClientId: this.clientId,
          },
          data: {
            EventFullName: this.eventName,
            EventShortName: this.eventName,
            EventStartDate: startD,
            EventEndDate: endD,
            TimeZone: this.defaultUserTimeZone,
          },
        };
        

        await axios
          .post(APIs.CloneEvent, JSON.stringify(requestData), {
            headers: headers,
          })
          .then(async (response) => {
            if (response.data.status == 0) {
              var eventDetails = {
                EventFullName: this.eventName,
                EventStartDate: startD,
                EventEndDate: endD,
                TimeZone: this.defaultUserTimeZone,
                DocPath: response.data.statusDoc,
              };
              store.commit("setTempAdminEvent", eventDetails);

              //this.eventName = null;
              //bus.$emit("toggleLoader", false);
              //alert("completed");
              await vm.CreateEventProgress();

              // $("#create_employee_ModalCenter").modal("hide");
              // router.push("/eventoverview#ManageMyEvents");
            }
          })
          .catch((error) => {
            debugger;
            //self.IsSubmitting = false;
            console.log("Error:" + error);
          });
      } else {
        this.showErrorMsg = true;
      }
    },
    async GetEventDetails() {
      vm.EventData = vm.getCurrentEvent();
      vm.EventData.EventStartDateTime = this.SetTimeByZone(
        new Date(vm.EventData.EventStartDate.seconds * 1000).toUTCString(),
        vm.EventData.TimeZone
      );
      vm.EventData.EventEndDateTime = this.SetTimeByZone(
        new Date(vm.EventData.EventEndDate.seconds * 1000).toUTCString(),
        vm.EventData.TimeZone
      );

      var brandingData = await vm.getBrandingJSONDetails(
        vm.event_collectionName + "/Branding/Branding.json"
      );
      if (brandingData && brandingData.data && brandingData.data.HostInfo) {
        var hostInfo = brandingData.data.HostInfo;
        vm.HostInfo = new Object();
        vm.HostInfo.Name =
          hostInfo && hostInfo.Name == undefined ? "" : hostInfo.Name;
        vm.HostInfo.Profile =
          hostInfo && hostInfo.Profile == undefined ? "" : hostInfo.Profile;
        vm.HostInfo.Logo =
          hostInfo && hostInfo.Logo == undefined ? "" : hostInfo.Logo;
        // alert(vm.EventData.EventStartTimestamp)
        // alert(vm.EventData.EventStartDate)
        vm.EventData.EventStartTimestamp =
          vm.EventData.EventStartDate == undefined
            ? 0
            : vm.EventData.EventStartDate.seconds * 1000;
        vm.EventData.EventEndTimestamp =
          vm.EventData.EventEndDate == undefined
            ? 0
            : vm.EventData.EventEndDate.seconds * 1000;
        var dateFormat = require("dateformat");
        vm.EventData.EventStartDateStr = dateFormat(
          new Date(vm.EventData.EventStartTimestamp),
          "mm/dd/yyyy"
        );
        vm.EventData.EventEndDateStr = dateFormat(
          new Date(vm.EventData.EventEndTimestamp),
          "mm/dd/yyyy"
        );
        //vm.EventData.EventStartDateStr = "10/16/2020";
        //vm.EventData.EventEndDateStr = dateFormat(new Date(vm.EventData.EventEndTimestamp), "yyyy-mm-dd");
        vm.appColorHexCodeType = brandingData.data["appColorHexCodeType"];
        vm.headerColorsHexCode = brandingData.data["headerColorsHexCode"];
        //alert(vm.appColorHexCodeType)
      }
      // vm.EventData = {
      //   EventFullName: "aaaaaa",
      //   LocationType: { Id: 1, Name: "In-person" },
      //   EventTypeId: 1,
      // };
    },
    async GetEventDetails2() {
      axios
        .get(
          APIs.EventBrandingJsonData +
            "?iid=OA_UAT" +
            "&cid=" +
            vm.clientId +
            "&eid=" +
            vm.eventId
        )
        .then(async (res) => {
          if (res.data.status == 0) {
            var brandingData = res.data.result;

            vm.HostInfo = brandingData.HostInfo;
            vm.clientName = brandingData.HostInfo.Name;
            vm.clientLogoUrl = brandingData.HostInfo.Logo;
            vm.clientProfile = brandingData.HostInfo.Profile;

            // if (brandingData.ClientInfo) {
            //   vm.desktopBanner =
            //     brandingData.ClientInfo.EventListAssets.banner2048x88;
            //   vm.mobileBanner =
            //     brandingData.ClientInfo.EventListAssets.banner750x103;
            //   // vm.BannerURL =
            //   //   brandingData.ClientInfo.EventListAssets.banner2048x88;
            // }
            // // else {
            // //   vm.BannerURL == "";
            // // }
            var dateFormat = require("dateformat");

            var obj = new Object();

            obj.EventFullName = brandingData.EventInfo.EventFullName;
            obj.IsPublished = brandingData.EventInfo.IsPublished;

            obj.EventTimezone = brandingData.EventInfo.TimeZone; // moment.tz.guess();
            //obj.EventTimezoneZ = moment.tz.guess();

            obj.EventLogo = brandingData.EventInfo.EventLogo;
            obj.EventBannerShare = brandingData.EventInfo.EventBannerShare;
            obj.Description = brandingData.EventInfo.Description;
            vm.AllowRegistration =
              brandingData.EventInfo.AllowRegistration == undefined
                ? true
                : brandingData.EventInfo.AllowRegistration;
            obj.EventStartDate = dateFormat(
              brandingData.EventInfo.EventStartDate,
              "mmm dd, hh:MM TT"
            );
            obj.EventEndDate = dateFormat(
              brandingData.EventInfo.EventEndDate,
              "mmm dd, hh:MM TT"
            );
            obj.EventStartDateZ = vm.GetTimeByZone(
              brandingData.EventInfo.EventStartDate,
              brandingData.EventInfo.TimeZone
            );
            obj.EventStartTimestamp = parseInt(
              obj.EventStartDateZ.getTime() / 1000
            );
            obj.EventStartDateZ = dateFormat(
              obj.EventStartDateZ,
              "mmm dd, hh:MM TT"
            );
            obj.EventEndDateZ = vm.GetTimeByZone(
              brandingData.EventInfo.EventEndDate,
              brandingData.EventInfo.TimeZone
            );
            obj.EventEndTimestamp = parseInt(
              obj.EventEndDateZ.getTime() / 1000
            );
            obj.EventEndDateZ = dateFormat(
              obj.EventEndDateZ,
              "mmm dd, hh:MM TT"
            );
            obj.EventDateStringLabel =
              obj.EventStartDate != obj.EventEndDate
                ? obj.EventStartDate +
                  " to " +
                  obj.EventEndDate +
                  " " +
                  obj.EventTimezoneZ
                : obj.EventStartDate + " " + obj.EventTimezoneZ;

            vm.EventData = obj;
            vm.EventData = brandingData.EventInfo;
          }
        });
    },
    SaveBasicSetup() {
      vm.SaveEventinfo();
      //vm.$emit("OnUpdateBasicSetupSuccess");
    },
    CancelBasicSetup() {
      store.commit("setClonedTemplateMasterDetails", {});
      router.push({ name: "EventShowCase" });
      // vm.$emit("OnCancelBasicSetupSuccess");
    },
    SaveEventinfo() {
      vm.SaveingBasicSetup = true;
      bus.$emit("toggleLoader", true);
      let dataObj = new Object();
      dataObj.EventFullName = vm.EventData.EventFullName;
      dataObj.EventShortName = vm.EventData.EventFullName;
      dataObj.Description = vm.EventData.Description
        ? vm.EventData.Description
        : "";
      dataObj.EventType = vm.EventData.EventTypeId;
      dataObj.EventTypeId = vm.EventData.EventTypeId;
      dataObj.AllowRegistration =
        vm.EventData.EventTypeId == 2 && vm.EventData.AllowRegistration;
      // dataObj.Description = vm.EventData.Name;
      // dataObj.Description = vm.EventData.Name;
      dataObj.LocationType = vm.EventData.LocationType;
      dataObj.TimeZone = vm.EventData.TimeZone;
      // dataObj.StartDate = new Date(vm.EventData.EventStartDateStr);
      // dataObj.EndDate = new Date(vm.EventData.EventEndDateStr);

      // dataObj.StartDateTZ = moment(vm.EventData.EventStartDateTime).format(
      //   "MMM DD, YYYY"
      // );
      // dataObj.StartTimeTZ = moment(vm.EventData.EventStartDateTime).format(
      //   "hh:mm A"
      // );
      // dataObj.EndDateTZ = moment(vm.EventData.EventEndDateTime).format(
      //   "MMM DD, YYYY"
      // );
      // dataObj.EndTimeTZ = moment(vm.EventData.EventEndDateTime).format(
      //   "hh:mm A"
      // );
      debugger;
      dataObj.EventStartDate = vm.GetTimeByZone(
        vm.EventData.EventStartDateTime,
        vm.EventData.TimeZone
      );
      dataObj.EventEndDate = vm.GetTimeByZone(
        vm.EventData.EventEndDateTime,
        vm.EventData.TimeZone
      );
      // dataObj.EventStartDate = vm.EventData.EventStartDateTime;
      // dataObj.EventEndDate = vm.EventData.EventEndDateTime;
      dataObj.StartDate = dataObj.EventStartDate;
      dataObj.EndDate = dataObj.EventEndDate;
      dataObj.DefaultLanguage = vm.EventData.DefaultLanguage;
      dataObj.EventAccessType = vm.EventData.EventAccessType;
      //alert(dataObj.TimeZone);
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${vm.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
        data: dataObj,
      };
      axios
        .post(APIs.SaveEventAPI, requestData, { headers: headers })
        .then(function (res) {
          vm.SaveingBasicSetup = false;
          bus.$emit("toggleLoader", false);
          if (res.data.status == 200) {
            vm.showSnackbar("Data updated", "success", "top");
            delete dataObj.EventType;
            delete dataObj.StartDate;
            delete dataObj.EndDate;
            delete dataObj.StartDateTimeStamp;
            delete dataObj.EndDateTimeStamp;

            dataObj.EventStartDate = moment
              .tz(
                dataObj.EventStartDate ? dataObj.EventStartDate : new Date(),
                dataObj.TimeZone
              )
              .format("YYYY-MM-DDTHH:mm:SS");
            dataObj.EventEndDate = moment
              .tz(
                dataObj.EventEndDate ? dataObj.EventEndDate : new Date(),
                dataObj.TimeZone
              )
              .format("YYYY-MM-DDTHH:mm:SS");

            if (vm.appColorHexCodeType == "headerColorsHexCodeLight") {
              vm.headerColorsHexCode = vm.LightTheme;
            } else if (vm.appColorHexCodeType == "headerColorsHexCodeDark") {
              vm.headerColorsHexCode = vm.DarkTheme;
            }
            vm.setBrandingJson([
              { key: "EventInfo", obj: dataObj },
              {
                key: null,
                obj: { appColorHexCodeType: vm.appColorHexCodeType },
              },
              { key: "headerColorsHexCode", obj: vm.headerColorsHexCode },
            ]);
            //vm.setBannerKey(brandingSessionKey, brandingSubKeyValue);

            dataObj.StartDateTimeStamp = {
              seconds: vm.EventData.EventStartTimestamp,
              nanoseconds: 0,
            };
            dataObj.EndDateTimeStamp = {
              seconds: vm.EventData.EventEndTimestamp,
              nanoseconds: 0,
            };
            var themeChanged = true;
            // if(store.state.EventBranding && store.state.EventBranding.length>0 && store.state.EventBranding[0].themeName)
            // {
            //   if(store.state.EventBranding[0].themeName!= vm.appColorHexCodeType)
            //   {
            //     alert()
            //     themeChanged = true;
            //   }
            // }
            vm.UpdateLocalStorage(dataObj);
            vm.$emit("OnUpdateBasicSetupSuccess");
            if (themeChanged) {
              // bus.$emit("toggleLoader", true);
              vm.showSnackbar("Applying Theme...", "success", "top");
              // bus.$emit("toggleLoader", false);
            }
          } else {
            vm.showSnackbar("Data not updated!", "error", "top");
          }
        })
        .catch((e) => {
          console.log(e);
          vm.SaveingBasicSetup = false;
          bus.$emit("toggleLoader", false);
          vm.showSnackbar("Something went wrong!", "error", "top");
        });
    },
    UpdateLocalStorage(dataObj) {
      if (dataObj) {
        this.$store.state.locale = dataObj.DefaultLanguage;
        store.commit("addEventName", dataObj.EventFullName);
        //store.commit("addEventSdate", dataObj.EventStartDate);
        store.commit("addEventSdate", dataObj.StartDateTimeStamp);
        //store.commit("addEventEdate", dataObj.EventEndDate);
        store.commit("addEventEdate", dataObj.EndDateTimeStamp);
        store.commit("addZone", dataObj.TimeZone);
        //store.commit("addZone", dataObj.TimeZone);

        let currentEvent = vm.$store.state.historyEvent;
        if (currentEvent) {
          currentEvent.EventFullName = dataObj.EventFullName;
          currentEvent.EventShortName = dataObj.EventFullName;
          currentEvent.Description = dataObj.Description;
          currentEvent.EventTypeId = dataObj.EventTypeId;
          currentEvent.AllowRegistration = dataObj.AllowRegistration;
          currentEvent.LocationType = dataObj.LocationType;
          currentEvent.TimeZone = dataObj.TimeZone;
          currentEvent.EventStartDate = dataObj.StartDateTimeStamp;
          currentEvent.EventEndDate = dataObj.EndDateTimeStamp;
          currentEvent.EventStartDateTimestamp =
            dataObj.StartDateTimeStamp.seconds;
          currentEvent.EventEndtDateTimestamp =
            dataObj.EndDateTimeStamp.seconds;
          // currentEvent.EventStartDate = dataObj.StartDateTZ;
          // currentEvent.EventEndDate = dataObj.EndDateTZ;
          // currentEvent.EventEndDate = dataObj.StartTimeTZ;
          // currentEvent.EventEndTime = dataObj.EndTimeTZ;
          currentEvent.DefaultLanguage = dataObj.DefaultLanguage;
          currentEvent.EventAccessType = dataObj.EventAccessType;
          vm.$store.state.historyEvent = currentEvent;
        }
        let eventBranding = this.$store.getters.getEventBranding;
        if (eventBranding) {
          eventBranding[0].themeName = vm.appColorHexCodeType;
          eventBranding[0].topBar = vm.headerColorsHexCode.topBar;
          eventBranding[0].headerBar = vm.headerColorsHexCode.headerBar;
          eventBranding[0].fontBar = vm.headerColorsHexCode.fontBar;
          eventBranding[0].sideNavigationAndIconColor =
            vm.headerColorsHexCode.sideNavigationAndIconColor;
          store.commit("addEventBranding", eventBranding[0]);
        }
        let events = store.getters.getMappedEvent;
        if (events && events.length > 0) {
          for (var i = 0; i < events.length; i++) {
            if (events[i].EventId == vm.EventData.EventId) {
              events[i].EventFullName = dataObj.EventFullName;
              events[i].EventShortName = dataObj.EventFullName;
              events[i].Description = dataObj.Description;
              events[i].EventTypeId = dataObj.EventTypeId;
              events[i].AllowRegistration = dataObj.AllowRegistration;
              events[i].LocationType = dataObj.LocationType;
              events[i].TimeZone = dataObj.TimeZone;
              events[i].EventStartDate = dataObj.StartDateTimeStamp;
              events[i].EventEndDate = dataObj.EndDateTimeStamp;
              events[i].EventStartDateTimestamp =
                dataObj.StartDateTimeStamp.seconds;
              events[i].EventEndtDateTimestamp =
                dataObj.EndDateTimeStamp.seconds;
              // events[i].EventStartDate = dataObj.StartDateTZ;
              // events[i].EventEndDate = dataObj.EndDateTZ;
              // events[i].EventEndDate = dataObj.StartTimeTZ;
              // events[i].EventEndTime = dataObj.EndTimeTZ;
              events[i].DefaultLanguage = dataObj.DefaultLanguage;
              events[i].EventAccessType = dataObj.EventAccessType;
              break;
            }
          }
          store.commit("setMappedEvent", events);
        }
      }
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MM/DD/YYYY HH:mm");
      return date;
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    setBrandingJson(mainKey, subKeyValObj = null) {
      let dataArr = [];
      if (Array.isArray(mainKey)) {
        for (let item of mainKey) {
          //if (typeof item.obj == "object") {
          dataArr.push({
            mainKey: item.key,
            subKeys: Object.keys(item.obj),
            subKeyValObj: item.obj,
          });
          // } else {
          //   dataArr.push({
          //     mainKey: null,
          //     subKeys: item.key,
          //     subKeyValObj: item.obj,
          //   });
          // }
        }
      } else {
        let subKeys = Object.keys(subKeyValObj);
        dataArr.push({
          mainKey: mainKey,
          subKeys: subKeys,
          subKeyValObj: subKeyValObj,
        });
      }
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${vm.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
        data: dataArr,
      };
      axios.post(APIs.SaveEventBrandingJson, requestData, { headers: headers });
    },
  },
};
</script>